export const QUERY_MOBILE = {
    APP_WITH_DEEPLINK_REDIRECT: 'appWithDeeplinkRedirect',
    IS_ANDROID: 'isAndroid',
    REDIRECT_DELAY: 'redirectDelay',
    MOBILE_APP: 'mobileApp',
    TOKEN: 'token',
    NEXT: 'next',
    ID: 'id',
    SLUG: 'slug',
    COUNTRY_CODE: 'countryCode',
    COUNTRY_NAME: 'countryName',
    OS: 'os',
    APP_SID: 'app_sid',
    SOURCE: 'source'
} as const;
